export const applicationCountries = {
  fr: '🇫🇷',
  be: '🇧🇪',
  it: '🇮🇹',
  nl: '🇳🇱',
} as const
